import { Link } from 'react-router-dom';

const ClubSummary = (props) => {
  const { club, clubMembership, page } = props;
  if (page === 'Signup') {
    return <div dangerouslySetInnerHTML={{ __html: club.content }} />;
  }
  return (
    <>
      <div className="c7-checkout-summary__buttons">
        <Link
          to={`/profile/club-membership/${clubMembership.id}/shipment`}
          className="c7-button"
        >
          Adjust Your Shipment
        </Link>
      </div>
      <br />
      <div dangerouslySetInnerHTML={{ __html: club.content }} />
      <br />
      <div className="c7-checkout-summary__buttons">
        <Link
          to={`/profile/club-membership/${clubMembership.id}/shipment`}
          className="c7-button"
        >
          Adjust Your Shipment
        </Link>
      </div>
    </>
  );
};

export default ClubSummary;
